<template>
  <v-main>
    <v-container>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0 ml-n4">Renegociar Faturas</v-toolbar-title>
      </v-toolbar>
      <v-alert type="error" v-if="errorMessage" class="mb-6">{{ errorMessage }}</v-alert>
      <v-form ref="form" @submit.prevent>
        <template v-for="(invoice, index) in fields.invoices">
          <p class="title" :key="'title-' + index">{{ invoice.invoice_date | moment('MMMM YYYY') }}</p>
          <v-row flex-wrap v-for="(item, itemIndex) in invoice.items" :key="'item-'+ index + '-' + itemIndex">
            <v-col class="order-4 order-md-1" cols="6" md="3">
              <v-menu
                :ref="'due_date_menu_' + index + '_' + itemIndex"
                v-model="item.due_date_menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    label="Mês de referência"
                    :value="$moment(item.due_date, 'YYYY-MM').format('MM/YYYY')"
                    :rules="[...fields.invoice_rules.due_date, ...invoice.apiErrors[itemIndex].due_date]"
                    type="text"
                    prepend-inner-icon="mdi-calendar-blank"
                    readonly
                    @input="invoice.apiErrors[itemIndex].due_date = []"
                    v-on="on"
                    outlined dense
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="item.due_date"
                  no-title
                  type="month"
                  :min="($moment().date() > 5) ? $moment().add(1, 'months').format('YYYY-MM-DD') : $moment().format('YYYY-MM-DD')"
                  locale="pt-br"
                  @input="item.due_date_menu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col class="order-1 order-md-2" cols="9" sm="10" md="7">
              <v-autocomplete
                label="Item *"
                v-model="item.invoice_item"
                :rules="[...fields.invoice_rules.invoice_item, ...invoice.apiErrors[itemIndex].joined_id, ...invoice.apiErrors[itemIndex].category]"
                :items="invoice.options.invoice_item"
                @input="invoice.apiErrors[itemIndex].joined_id = []; invoice.apiErrors[itemIndex].category = []"
                outlined dense
              ></v-autocomplete>
            </v-col>
            <v-col class="order-3 order-md-4" cols="12" md="9">
              <v-text-field
                label="Descrição *"
                v-model="item.description"
                :rules="[...fields.invoice_rules.description, ...invoice.apiErrors[itemIndex].description]"
                type="text"
                @input="invoice.apiErrors[itemIndex].description = []"
                outlined dense
              ></v-text-field>
            </v-col>
            <v-col class="order-5 order-md-5" cols="6" md="3">
              <decimal-number
                label="Valor *"
                v-model="item.installment_amount"
                :rules="[...invoice.apiErrors[itemIndex].installment_amount]"
                @input="invoice.apiErrors[itemIndex].installment_amount = []"
                outlined dense
              ></decimal-number>
            </v-col>
            <v-col class="order-2 order-md-3" cols="3" sm="2" md="2">
              <v-btn text color="error" class="my-n2 my-md-0" :fab="$vuetify.breakpoint.smAndDown" @click="invoice.items.splice(itemIndex, 1)">
                <v-icon>mdi-delete</v-icon>
                <span class="hidden-sm-and-down">Excluir</span>
              </v-btn>
            </v-col>
            <v-col v-if="itemIndex > 0" cols="12" class="mb-4">
              <v-divider></v-divider>
            </v-col>
          </v-row>
        </template>
        <v-btn color="success" :disabled="sending" :loading="sending" @click="send()">Salvar</v-btn>
        <v-btn text color="error" :disabled="sending" @click="$router.go(-1)">Cancelar</v-btn>
      </v-form>
    </v-container>
    <app-loading :visible="loading"></app-loading>
  </v-main>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import AppLoading from '@/components/Loading'
import DecimalNumber from '@/components/DecimalNumber'

export default {
  name: 'userForm',
  components: {
    AppLoading,
    DecimalNumber
  },
  data: () => ({
    loading: false,
    fields: {
      invoices: [],
      invoice_rules: {
        invoice_item: [
          v => !!v || 'O item da fatura é obrigatório'
        ],
        description: [
          v => !!v || 'A descrição é obrigatória'
        ],
        installment_amount: [
          v => !!v || 'O valor é obrigatório'
        ],
        due_date: [
          v => !!v || 'A data é obrigatória'
        ]
      }
    },
    sending: false,
    errorMessage: null
  }),
  computed: {
    apiData () {
      let data = {}
      for (let key in this.fields) {
        if (this.fields[key].value) data[key] = this.fields[key].value
      }
      return data
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    translateCategory (category) {
      if (category === 'fundraising') return 'Parcela'
      if (category === 'interest_and_fines') return 'Multa/juros'
      if (category === 'renegotiation') return 'Renegociação'
      if (category === 'additional') return 'Adicional'
      if (category === 'discount') return 'Desconto'
      return category
    },
    generateApiErrors (apiErrors) {
      for (let key in apiErrors) {
        if (this.fields[key]) this.fields[key].apiErrors = apiErrors[key]
      }
    },
    send () {
      let vue = this

      if (vue.$refs.form.validate()) {
        vue.sending = true
        vue.errorMessage = null

        let promises = []

        for (let invoiceIndex in this.fields.invoices) {
          let installments = [...new Set(vue.fields.invoices[invoiceIndex].items.map(e => { return e.due_date }))].sort()
          let data = vue.fields.invoices[invoiceIndex].items.map((e, i) => {
            let item = e.invoice_item.split('+')
            return {
              joined_id: item[1],
              category: (item[0] === 'fundraising') ? 'renegotiation' : item[0],
              installment: installments.findIndex(f => { return f === e.due_date }) + 1,
              installment_amount: e.installment_amount,
              description: e.description,
              due_date: (e.due_date.length < 10) ? e.due_date + '-01' : e.due_date,
              notes: ''
            }
          })

          promises.push(new Promise((resolve, reject) => {
            axios('invoices/' + vue.fields.invoices[invoiceIndex].invoice_id + '/renegotiations', {
              method: 'post',
              data
            })
              .then(response => {
                if (response) {
                  vue.sending = false
                  resolve()
                }
              })
              .catch(error => {
                if (error.response && error.response.status === 422) {
                  if (error.response.data) vue.generateApiErrors(invoiceIndex, error.response.data)
                  vue.errorMessage = 'Verifique os campos com erro'
                } else {
                  vue.errorMessage = 'Houve um erro ao processar seu pedido, por favor contacte o suporte técnico'
                }
                reject(error)
              })
          }))
        }

        Promise.all(promises)
          .then(() => {
            vue.sending = false
            vue.SET_SNACKBAR({ text: 'Fatura(s) renegociadas' })
            vue.$router.go(-1)
          })
          .catch(() => {
            vue.sending = false
          })
      } else {
        vue.errorMessage = 'Verifique os campos com erro'
      }
    }
  },
  created () {
    if (this.$route.query && this.$route.query.invoices) {
      let invoices = this.$route.query.invoices.split(',')
      let promises = []
      let vue = this
      vue.loading = true

      for (let i = 0; i < invoices.length; i++) {
        promises.push(new Promise((resolve, reject) => {
          axios.get('invoices/' + invoices[i])
            .then(response => {
              let items = []
              let apiErrors = []
              let invoiceItemOptions = response.data.items.map(e => {
                return {
                  value: e.category + '+' + e.joined_id,
                  text: vue.translateCategory(e.category) + ': ' + e.description
                }
              })

              const { advancePaymentPercent, startsAt } = vue.$route.query

              if (advancePaymentPercent) {
                for (let index in response.data.items) {
                  items.push({
                    invoice_item: response.data.items[index].category + '+' + response.data.items[index].joined_id,
                    installment_amount: parseFloat(advancePaymentPercent) * response.data.items[index].installment_amount,
                    description: 'Renegociação - ' + response.data.items[index].description + ' - ' + vue.$moment(response.data.invoice_date).format('MMM/YY') + ' - ' + 'Adiantamento',
                    // due_date: (vue.$moment().date() >= 5) ? vue.$moment(startsAt).add(i, 'months').format('YYYY-MM') : vue.$moment(startsAt).add((i - 1), 'months').format('YYYY-MM'),
                    due_date: vue.$moment(startsAt).format('YYYY-MM'),
                    due_date_menu: false
                  })
                  apiErrors.push({
                    joined_id: [],
                    category: [],
                    description: [],
                    installment_amount: [],
                    due_date: []
                  })
                }
              }

              for (let i = 1; i <= vue.$route.query.installments; i++) {
                for (let j in response.data.items) {
                  items.push({
                    invoice_item: response.data.items[j].category + '+' + response.data.items[j].joined_id,
                    installment_amount:
                      advancePaymentPercent
                        ? (response.data.items[j].installment_amount - (parseFloat(advancePaymentPercent) * response.data.items[j].installment_amount)) / parseInt(vue.$route.query.installments)
                        : response.data.items[j].installment_amount / parseInt(vue.$route.query.installments),
                    description: 'Renegociação - ' + response.data.items[j].description + ' - ' + vue.$moment(response.data.invoice_date).format('MMM/YY') + ' - ' + i + '/' + vue.$route.query.installments,
                    // due_date: (vue.$moment().date() >= 5) ? vue.$moment(startsAt).add(i, 'months').format('YYYY-MM') : vue.$moment(startsAt).add((i - 1), 'months').format('YYYY-MM'),
                    due_date: advancePaymentPercent ? vue.$moment(startsAt).add(i, 'months').format('YYYY-MM') : vue.$moment(startsAt).add(i - 1, 'months').format('YYYY-MM'),
                    due_date_menu: false
                  })
                  apiErrors.push({
                    joined_id: [],
                    category: [],
                    description: [],
                    installment_amount: [],
                    due_date: []
                  })
                }
              }

              if (vue.$route.query.includeTax) {
                let totalPerJoined = {}
                let joinedName = {}
                let fineForDelay = response.data.celebration.fine_for_delay || 3
                let dailyInterest = response.data.celebration.daily_interest || 1

                for (let j in response.data.items) {
                  if (!totalPerJoined[response.data.items[j].joined_id]) {
                    totalPerJoined[response.data.items[j].joined_id] = 0
                    joinedName[response.data.items[j].joined_id] = response.data.items[j].description
                  }
                  if (response.data.items[j].category === 'discount') totalPerJoined[response.data.items[j].joined_id] -= response.data.items[j].installment_amount
                  else if (response.data.items[j].category !== 'interest_and_fines') totalPerJoined[response.data.items[j].joined_id] += response.data.items[j].installment_amount
                }

                for (let key in totalPerJoined) {
                  let daysDiff = vue.$moment().utcOffset(0).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).diff(vue.$moment(response.data.due_date), 'days')

                  if (daysDiff > 0) {
                    let amountInterestFines = ((totalPerJoined[key] * fineForDelay / 100) + (totalPerJoined[key] * dailyInterest / 3000 * daysDiff)).toFixed(2)

                    invoiceItemOptions.push({
                      value: 'interest_and_fines+' + key + '+' + response.data.invoice_date,
                      text: 'Multa/Juros: ' + vue.$moment(response.data.invoice_date).format('MMMM YYYY')
                    })

                    if (advancePaymentPercent) {
                      items.push({
                        invoice_item: 'interest_and_fines+' + key + '+' + response.data.invoice_date,
                        installment_amount: parseFloat(advancePaymentPercent) * amountInterestFines,
                        description: 'Multa/Juros - ' + joinedName[key] + ' - ' + vue.$moment(response.data.invoice_date).format('MMM/YY') + ' - ' + i + '/' + vue.$route.query.installments + ' - ' + 'Adiantamento',
                        due_date: (vue.$moment().date() >= 5) ? vue.$moment().add(i, 'months').format('YYYY-MM') : vue.$moment().add((i - 1), 'months').format('YYYY-MM'),
                        due_date_menu: false
                      })

                      apiErrors.push({
                        joined_id: [],
                        category: [],
                        description: [],
                        installment_amount: [],
                        due_date: []
                      })
                    }

                    for (let i = 1; i <= vue.$route.query.installments; i++) {
                      items.push({
                        invoice_item: 'interest_and_fines+' + key + '+' + response.data.invoice_date,
                        installment_amount:
                          advancePaymentPercent
                            ? (amountInterestFines - (parseFloat(advancePaymentPercent) * amountInterestFines)) / parseInt(vue.$route.query.installments)
                            : amountInterestFines / parseInt(vue.$route.query.installments),
                        description: 'Multa/Juros - ' + joinedName[key] + ' - ' + vue.$moment(response.data.invoice_date).format('MMM/YY') + ' - ' + i + '/' + vue.$route.query.installments,
                        due_date: (vue.$moment().date() >= 5) ? vue.$moment().add(i, 'months').format('YYYY-MM') : vue.$moment().add((i - 1), 'months').format('YYYY-MM'),
                        due_date_menu: false
                      })

                      apiErrors.push({
                        joined_id: [],
                        category: [],
                        description: [],
                        installment_amount: [],
                        due_date: []
                      })
                    }
                  }
                }
              }

              vue.fields.invoices.push({
                invoice_id: invoices[i],
                invoice_date: response.data.invoice_date,
                items,
                options: {
                  invoice_item: invoiceItemOptions
                },
                apiErrors
              })
              resolve()
            })
            .catch(error => {
              reject(error)
            })
        }))
      }

      Promise.all(promises)
        .then(() => {
          vue.loading = false
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.$router.go(-1)
        })
    }
  }
}
</script>
